var styleDataHash = "1d95235e";
const injectCss = () => {
  var css = `.alkYb{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var insert_modal_default = {
  "input": "alkYb"
};
export {
  insert_modal_default as default,
  injectCss
};
//# sourceMappingURL=insert-modal-scss.js.map
